import Skeleton from '@wconcept/wconcept-ui-renewal/components/atoms/Skeleton';

import * as S from './style';

interface IProps {
  isDesktop?: boolean;
  bgType?: 'white' | 'black' | 'opacity' | string;
  bgColor?: string;
}

const CouponItem2Skeleton = ({
  isDesktop,
  bgType = 'white',
  bgColor,
}: IProps) => (
  <S.Box
    className="coupon-item-skeleton item"
    $bgType={bgType}
    $bgColor={bgColor}
  >
    <div className="skeleton-wrap">
      <div className="text-wrap">
        <Skeleton className="title" />
        <Skeleton className="desc" />
      </div>
      <Skeleton className="icon" />
    </div>
  </S.Box>
);

export default CouponItem2Skeleton;
